import { getPreAssessmentWithSteps as GB, applyStepConfig as stepsGB } from './gb.fixture';
import {
  getPreAssessmentWithSteps as other,
  applyStepConfig as stepsOther,
} from './default.fixture';

const countryFixtureMap = { GB, other };

export const stepMap = {
  GB: Object.keys(stepsGB),
  other: Object.keys(stepsOther),
};

export const getPreAssessmentWithSteps = (country = 'other', applySteps = []) =>
  (countryFixtureMap[country] || countryFixtureMap.other)(applySteps);
